/**
 * The circle next to the user's name in the header (C-27): the signed-in
 * user's own photo when there is one, else the person icon. A read that is 404
 * or fails, and a signed image that fails to load, all show the icon.
 */

import { useMyPhoto } from '@/hooks/data/useMyPhoto';
import { cn } from '@/utils';
import { User } from 'lucide-react';
import React, { useState } from 'react';

const CIRCLE = 'w-8 h-8 rounded-full flex-shrink-0';

export const HeaderAvatar: React.FC = () => {
  const { data } = useMyPhoto();
  // The URL whose image failed to load; a new URL (a new photo, or a refetch) gets a fresh try.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = data?.url;

  if (url && url !== failedUrl) {
    return (
      <img
        src={url}
        alt="Your photo"
        referrerPolicy="no-referrer"
        onError={() => setFailedUrl(url)}
        className={cn(CIRCLE, 'object-cover bg-white/10')}
      />
    );
  }
  return (
    <div
      data-testid="header-avatar-icon"
      className={cn(
        CIRCLE,
        'bg-gradient-to-br from-brand-500 to-accent-500 flex items-center justify-center',
      )}
    >
      <User className="h-4 w-4 text-white" aria-hidden="true" />
    </div>
  );
};
